import { generateUUID } from './../components/common/common-data';
import {
    // site page
    WAIT_INIT_SITE,
    SELECT_SITE,
    RE_SELECT_SITE,
    SELECT_SITE_MODE,
    GET_SITE_SUMMARY,
    GET_SITE_SUMMARY_SUCCESS,
    GET_SITE_SUMMARY_FAIL,

    // site form
    SAVE_ORGANIZATION_DATA,
    SAVE_ORGANIZATION_DATA_SUCCESS,
    SAVE_ORGANIZATION_DATA_FAIL, GET_DNS_SETTING, GET_DNS_SETTING_FAIL, GET_DNS_SETTING_SUCCESS,
} from "../actions/site/index";

const doAction = (state, action) => {  
    switch (action.type) {

    // site manager      
    case WAIT_INIT_SITE:
        return {
            ...state,
            errMsg: null,
            status: WAIT_INIT_SITE
        }
    case SELECT_SITE:
        return {
            ...state,
            selectSite: action.params.selectSite,
            reqUUID: action.params.reqUUID,
            status: SELECT_SITE
        }
    case SELECT_SITE_MODE:
        return {
            ...state,
            siteMode: action.params.siteMode,
            status: SELECT_SITE_MODE
        }
    case RE_SELECT_SITE:
        return {
            ...state,
            status: RE_SELECT_SITE,
            siteSummaryList: action.params.siteSummaryList,
            siteOptions: action.params.siteOptions,
            selectSite: action.params.selectSite,
            selectSiteName: action.params.selectSiteName,
            reqUUID: generateUUID(),
        }
    case GET_SITE_SUMMARY:
        return {
            ...state,            
            status: GET_SITE_SUMMARY,
            siteSummaryList: [],
            siteOptions: [],
            selectSite: 0,
            loading: true
        }
    case GET_SITE_SUMMARY_FAIL:
        return {
            ...state,            
            status: GET_SITE_SUMMARY_FAIL,
            loading: false
        }
    case GET_SITE_SUMMARY_SUCCESS:
        return {
            ...state,            
            status: GET_SITE_SUMMARY_SUCCESS,
            siteSummaryList: action.params.siteSummaryList,
            siteOptions: action.params.siteOptions,
            selectSite: action.params.selectSite,
            selectSiteName: action.params.selectSiteName,
            initialSetup: action.params.initialSetup,
            loading: false
        }

    // site form
    case SAVE_ORGANIZATION_DATA:
        return {
            ...state,
            status: SAVE_ORGANIZATION_DATA,
            siteOptions: [],
            errMsg: null
        }
    case SAVE_ORGANIZATION_DATA_SUCCESS:
        return {
            ...state,
            status: SAVE_ORGANIZATION_DATA_SUCCESS,
            siteOptions: action.params.siteOptions,
        }
    case SAVE_ORGANIZATION_DATA_FAIL:
        return {
            ...state,
            status: SAVE_ORGANIZATION_DATA_FAIL,
            siteOptions: [],
            errMsg: action.params.errMsg
        }

    case GET_DNS_SETTING:
        return {
            ...state,
            status: GET_DNS_SETTING,
            dnsList: [],
            loading: true
        }
    case GET_DNS_SETTING_FAIL:
        return {
            ...state,
            status: GET_DNS_SETTING_FAIL,
            loading: false
        }
    case GET_DNS_SETTING_SUCCESS:
        return {
            ...state,
            status: GET_DNS_SETTING_SUCCESS,
            dnsList: action.params,
            loading: false
        }
        default:
        return state;
    }
}

const siteReducers = (state = {
    errMsg: null,
    reqUUID: null,
    status: WAIT_INIT_SITE,
    loading: false,
    popLoading: false,
    siteMode: 'blocks',
    siteSummaryList: [],
    groupList: [],
    siteOptions: [],
    selectSite: 0,  
    selectSiteName: null,
    initialSetup: null,
    dnsList: []
  }, action) => {
    switch (action.type) {
      default:
        return doAction(state, action);
    }
  }
  
  export default siteReducers;